var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconReset(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5679 13.3195C11.2437 14.4669 9.54964 15.0974 7.7975 15.095C3.76709 15.095 0.5 11.8279 0.5 7.7975C0.5 3.76709 3.76709 0.5 7.7975 0.5C11.8279 0.5 15.095 3.76709 15.095 7.7975C15.095 9.35624 14.6061 10.8011 13.7742 11.9863L11.4463 7.7975H13.6355C13.6354 6.45199 13.1705 5.14782 12.3195 4.10561C11.4685 3.0634 10.2837 2.34714 8.96534 2.07798C7.64703 1.80882 6.27621 2.0033 5.08478 2.62851C3.89336 3.25372 2.95446 4.27128 2.42692 5.50906C1.89939 6.74684 1.8156 8.12885 2.18973 9.42129C2.56386 10.7137 3.37295 11.8373 4.48012 12.6018C5.58728 13.3664 6.92457 13.7251 8.26574 13.6172C9.60691 13.5092 10.8696 12.9414 11.8403 12.0096L12.5679 13.3195Z",
    fill: "#122945"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReset);
export default __webpack_public_path__ + "static/media/icon_reset.3de2a1508108e579ce748b786627415f.svg";
export { ForwardRef as ReactComponent };